export function newProductExecuteErrorText(error: unknown): string {
  const status =
    error != null && typeof error === "object" && "status" in error
      ? Number((error as { status: unknown }).status)
      : 0;
  const message = error instanceof Error ? error.message : String(error);
  if (status === 502 || status === 503 || status === 504) {
    return `Create did not finish (HTTP ${status}). ${message} Validate again before retrying; Megaventory may already have partial updates.`;
  }
  if (Number.isFinite(status) && status > 0) {
    return `Create failed (HTTP ${status}): ${message}`;
  }
  return message;
}
